import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import { Link } from "react-router-dom";

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      // Small delay for better UX
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookie-consent", "accepted");
    setIsVisible(false);
  };

  const declineCookies = () => {
    localStorage.setItem("cookie-consent", "declined");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-fade-in">
      <div className="container mx-auto max-w-4xl">
        <div className="bg-card border border-border rounded-lg shadow-2xl p-6 relative">
          <button
            onClick={declineCookies}
            className="absolute top-4 right-4 text-muted-foreground hover:text-foreground transition-colors"
            aria-label="Sluiten"
          >
            <X className="w-5 h-5" />
          </button>
          
          <div className="flex flex-col md:flex-row md:items-center gap-4 md:gap-6">
            <div className="flex-1 pr-8 md:pr-0">
              <h3 className="font-display text-lg font-bold text-foreground mb-2">
                Cookie Melding
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed">
                Wij gebruiken cookies om uw ervaring op onze website te verbeteren. 
                Door op &quot;Accepteren&quot; te klikken, gaat u akkoord met het gebruik van alle cookies. 
                Lees onze{" "}
                <Link to="/privacy" className="text-primary hover:underline">
                  privacyverklaring
                </Link>{" "}
                voor meer informatie.
              </p>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-3 shrink-0">
              <Button
                variant="outline"
                onClick={declineCookies}
                className="border-border text-foreground hover:bg-muted"
              >
                Weigeren
              </Button>
              <Button
                onClick={acceptCookies}
                className="bg-primary text-primary-foreground hover:bg-primary/90"
              >
                Accepteren
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
